export const MAX_SEARCH_HOTEL_DAYS = 28;
export const MAX_NUMBER_OF_ROOMS = 9;
export const MAX_ADULTS = 10;
export const DEFAULT_ADULTS = 2;
export const MAX_GUESTS = 40;
export const SHOW_LEFT_ROOM_NUM_THRESHOLD = 5;
export const DEFAULT_LIST_SHOW_NUM = 6;
export const DEFAULT_SUBLIST_SHOW_NUM = 3;
export const HOTEL_COMMON_SCRIPT_ID = "hotel_common_script";
export const MAX_STAY = 30;
export const DEFAULT_MIN_CALENDAR_STAY = 1;
export const DEFAULT_MAX_CALENDAR_STAY = 20;
